/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import * as _ from 'lodash';

import template from './last-verbed-tab.component.html';
import {objectTypeStateParams} from '../../common/filters/object-type-state-params';
import {getLastVerbedProfileKey, hydrateLastVerbedEntries} from './last-verbed.util';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TranslateModule, UIRouterModule],
  selector: 'adn-last-verbed-tab',
  template
})
export class LastVerbedTabComponent implements OnInit, OnDestroy {
  @Input() prefix: 'lastEdited' | 'lastViewed';

  lastVerbed: any[] = [];

  private unsubscribeProfile: () => void;

  constructor(
    @Inject(LocalUserProfile) private readonly localUserProfile: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const networkId = this.LocalNetworkProfile.getNetworkId();
    const app = this.localUserProfile.getCurrentApp();
    const profileKey = getLastVerbedProfileKey(this.prefix, networkId, app);
    const canSeeUsers = this.LocalUserPermissions.getAllNetworkPermissions().MANAGE_SYSTEM === true
      || this.LocalUserPermissions.getAllNetworkPermissions().SELF_SERVICE_USER_ADMIN === true;

    const hydrate = (theObj: any) => {
      this.lastVerbed = hydrateLastVerbedEntries(theObj, canSeeUsers);
    };

    this.unsubscribeProfile = this.localUserProfile.subscribe(profileKey, hydrate);
    hydrate(_.get(this.localUserProfile.get(), ['profile', profileKey]));
  }

  ngOnDestroy(): void {
    this.unsubscribeProfile?.();
  }

  getLastVerbedUiParams(lastVerb: any): Record<string, any> {
    return objectTypeStateParams(lastVerb, lastVerb?.objectType, lastVerb?.id);
  }
}
